// extracted by mini-css-extract-plugin
export var label = "_3r-1";
export var reminder = "_3r-0";